import type { IconData } from '@stacksjs/iconify-core'

export const contentWrite2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 16V9l6.49-6.49l7 7L7 16zm14.55-7.55a4.95 4.95 0 1 0-7-7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentWrite2
